// src/config.js

const config = {
    apiUrl: process.env.API_URL,
    debug: process.env.DEBUG === 'true'
};

export default config;